<template>
  <div>
    <app-table-header-item class="field_left extended">
      <app-input
          class="field field_search field_search_shorter"
          :class="{'extended': extended, 'field_search_shorter': fieldSearchShorter, 'field_search_bottom': fieldSearchBottom}"
          :label="label"
          inputClass="search clearable"
          :autocomplete="true"
          :clearable="false"
          :autocompleteSource="options"
          @autocompleteValueChanged="autocompleteValueChanged"
          @focus="onFocus"
          @blur="onBlur"
          @input="onInputValueChanged"
      >
      </app-input>
    </app-table-header-item>
    <app-table-header-item class="field_right">
      <ul class="selected_results" v-if="selectedItems.length !== 0">
        <li @click="removeAll" class="delete_all">
          {{ translations.removeAll }}
        </li>
        <li
            v-for="item in shownItems"
            @click="removeItem(item)"
        >
          {{ item }}
        </li>
        <li 
          v-if="isMoreButtonShown" 
          :title="$gettext('Zobrazit vše')"
          class="view_all" 
          @click="$emit('seeMoreClicked')"
        >…</li>
      </ul>
    </app-table-header-item>
  </div>
</template>

<script>

import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'

export default {
  name: 'dropdown-input',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    fieldSearchShorter: {
      type: Boolean,
      default: false
    },
    fieldSearchBottom: {
      type: Boolean,
      default: false
    },
    visibleResultLimit: {
      type: Number,
      default: 0
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      extended: false,
      selectedItems: []
    }
  },
  computed: {
    translations() {
      return {
        removeAll: this.$gettext('Odstranit vše')
      }
    },
    shownItems() {
      return this.visibleResultLimit > 0
        ? this.selectedItems.slice(0, this.visibleResultLimit)
        : this.selectedItems
    },
    isMoreButtonShown() {
      return this.visibleResultLimit > 0 && (this.selectedItems.length > this.visibleResultLimit)
    }
  },
  methods: {
    onFocus() {
      this.extended = true
    },
    onBlur() {
      this.extended = false
    },
    autocompleteValueChanged(value, item) {
      this.selectedItems.push(item[AUTOCOMPLETE_TITLE])
      this.$emit('autocompleteValueChanged', value, item)
    },
    removeItem(item) {
      this.selectedItems = this.selectedItems.filter(v => v !== item)
      this.$emit('removeItem', item)
    },
    removeAll() {
      this.selectedItems = []
      this.$emit('removeAll')
    },
    onInputValueChanged(text) {
      this.$emit('input', text)
    }
  },
  watch: {
    selected() {
      this.selectedItems = this.selected
    }
  }
}
</script>
